<div class="wrapper">
    <div class="container px-0"> 
            <h5 class="main-title">Best Practice</h5>
        <div class="row justify-content-center">
            <div class="col-md-6">
                <div class="card border">  
                    <div class="card-body p-0 text-center">
                      <h5 class="bg-info font-weight-bold mb-0 p-3 text-white">{{'paymentFaild.title'|translate}}</h5> 
                      <p class="mb-0 p-3">{{'paymentFaild.paymentfaildMessage'|translate}}</p>  
                        
                      <h5 class="bg-light font-weight-bold mb-0 p-3 text-info text-success">{{'paymentFaild.paymentFaildThankyou'|translate}} </h5> 
                    </div>
                </div> 
            </div>
        </div> 
    </div>
</div> 

<footer class="p-3">
    <div class="container p-0">
        <div class="d-flex justify-content-between align-items-center">
          <a class="btn btn-outline-primary" type="button" href="javascript:void(0)" (click)="onClickBack()">{{'button.back'|translate}}</a>
            <!-- <p class="mb-0">(5 of 5)</p> -->
          <a class="btn btn-primary" type="button" href="Screen-16.html">{{'button.next'|translate}}</a>
        </div>
    </div>
</footer> 
